import styled from 'styled-components';

export const Content = styled.div`
    display: flex;
    justify-content: space-between;
    color: #A3A3A3;
    font-weight: 400;
    font-size: 0.75rem;
`;
